import angular from 'angular'
import { emitter } from '../../../util.js'

angular.module('pub.bundle.step2', ['pub.bundle.step2.react']).controller('Step2Ctrl', Step2Ctrl)

/** @ngInject */
function Step2Ctrl(
  $state,
  $scope,
  $stateParams,
  $rootScope,
  $q,
  CollectiblesService,
  OddsService,
  ChannelsService,
  BundleCache,
) {
  // Create an event emitter instance
  var vm = this
  vm.channelId = $stateParams.channelId
  vm.parentId = $stateParams.parentId
  vm.isEvent = $stateParams.event
  vm.isChannelBundle = !!$stateParams.channelId
  vm.loading = false
  vm.guaranteedAmout = 0
  var collectibles = []
  var odds = []

  vm.productTypes = [
    { id: 1, name: 'Sticker' },
    { id: 2, name: 'Card' },
    { id: 3, name: 'Figure' },
  ]

  vm.editions = [
    { id: 1, name: '1' },
    { id: 2, name: '2' },
    { id: 3, name: '3' },
    { id: 4, name: '4' },
    { id: 5, name: '5' },
    { id: 6, name: '6' },
  ]

  vm.setTypes = [
    { id: 0, name: 'Standard' },
    { id: 1, name: 'Award' },
    { id: 2, name: 'Collectors Edition' },
  ]

  vm.productType = null
  vm.edition = null
  vm.setType = null

  var watch1 = $scope.$watch('vm.productType', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    emitter.emit('updateData', {
      productType: newVal,
      edition: vm.edition,
      setType: vm.setType,
    })
  })

  var watch2 = $scope.$watch('vm.edition', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    emitter.emit('updateData', {
      productType: vm.productType,
      edition: newVal,
      setType: vm.setType,
    })
  })

  var watch3 = $scope.$watch('vm.setType', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    emitter.emit('updateData', {
      productType: vm.productType,
      edition: vm.edition,
      setType: newVal,
    })
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
    watch3()
  })

  //start
  load()

  vm.removeSoldOut = function () {
    emitter.emit('removeSoldOut', {
      status: true,
    })
  }

  //function bind
  vm.back = function () {
    if (vm.isEvent) {
      $state.go('admin.event')
      return
    }
    $state.go('pub.bundles', { parentId: $stateParams.parentId })
  }

  vm.toogleAll = function () {
    var models = []
    var promise = []
    var isEnter = false
    vm.checkStep2 === true ? loop(vm.collectibles, true) : loop(vm.collectibles, false)

    function loop(data, isTog) {
      var len = collectibles.length
      for (var i = 0; i < len; i++) {
        if (collectibles[i].tog === !isTog && collectibles[i].progress === 4) {
          collectibles[i].tog = isTog
          collectibles[i]['id-b'] = parseInt($stateParams.id)
          if (isTog) {
            var model = {
              'id-b': parseInt($stateParams.id),
              o: 1000,
              'id-q': collectibles[i].id,
              g: false,
            }
            models.push(model)
          } else {
            if (collectibles[i].st === 0) {
              for (var j = 0; j < odds.length; j++) {
                if (odds[j]['id-q'] === collectibles[i].id) {
                  isEnter = true
                  promise.push(OddsService.deleteOdd(odds[j].id))
                  break
                }
              }
            } else {
              vm.collectibles[i].tog = true
            }
          }
        }
      }
    }

    if (!isEnter) {
      vm.checkStep2 = true
    }

    if (vm.checkStep2) {
      OddsService.save(parseInt($stateParams.id), models).then(function () {
        toastr.success('Saved!')
      })
    } else {
      $q.all(promise).then(
        function () {
          toastr.success('Deleted!')
        },
        function (err) {
          console.log(err)
        },
      )
    }
  }

  vm.toogleChange = function (item, index) {
    item.tog === true ? add(item) : remove(item, index)
  }

  vm.classDisabled = function () {
    for (var i = 0; i < collectibles.length; i++) {
      if (collectibles[i].progress === 4 && collectibles[i].tog === true) {
        return
      }
    }
    return 'is-disabled'
  }

  vm.save = function () {
    refreshOdds(odds)
    toastr.success('Saved!')
    if (vm.isEvent) {
      $state.go('pub.bundles.step3', {
        parentId: $stateParams.parentId,
        id: $stateParams.id,
        event: $stateParams.event,
        create: $stateParams.create,
        post: $stateParams.post,
      })
    }
  }

  //function pure
  function load() {
    vm.collectibles2 = {
      s3: $rootScope.urlS3,
      productType: vm.productType,
      edition: vm.edition,
      setType: vm.setType,
    }
  }

  function oddsRecursive(data) {
    var count = 0
    for (var i = 0; i < data.length; i++) {
      if (data[i].g !== undefined) {
        if (data[i].g === false) {
          count += data[i].o
        }
      } else {
        count += data[i].o
      }
    }
    return count
  }

  function add(item) {
    var model = {
      'id-b': parseInt($stateParams.id),
      o: 1000,
      'id-q': item.id,
      t: item.t,
      'img-t': item['img-t'],
      cr: item.cr,
      printCount: item.printCount,
      g: false,
    }

    if (odds.length === 0) {
      OddsService.save(model['id-b'], [model]).then(function () {
        odds.push(model)
        refreshOdds(odds)
      })
      return
    }

    var len = odds.length
    for (var i = 0; i < len; i++) {
      if (odds[i]['id-q'] !== item.id) {
        OddsService.save(model['id-b'], [model]).then(function () {
          odds.push(model)
          refreshOdds(odds)
        })
        return
      }
    }
  }

  function remove(item, index) {
    var copy = angular.copy(odds)
    var itemDelete
    var len = copy.length
    for (var i = 0; i < len; i++) {
      if (copy[i]['id-q'] === item.id) {
        itemDelete = copy[i]
        break
      }
    }

    if (itemDelete.id === undefined) {
      return
    }

    OddsService.deleteOdd(itemDelete.id).then(success, error)

    function success() {
      copy.remove(itemDelete)
      odds = copy
      refreshOdds(odds)
    }

    function error(result) {
      swal(result.error.message)
      vm.collectibles[index].tog = true
    }
  }

  function refreshOdds(odds) {
    BundleCache.addOdds(odds)
  }
}
